import Vue from 'vue';
import type { ActionTree, GetterTree, Module, MutationTree } from 'vuex';

/**
 * Module state
 */
interface State {
    caller:string;
}

const moduleState: State = {
    caller: localStorage.getItem('Base/caller')||'',
};

/**
 * Module getters
 */
const moduleGetters: GetterTree<State, any> = {
    caller(state: State) {
        return state.caller || '';
    },
};

/**
 * Module mutations
 */
const moduleMutations: MutationTree<State> = {
    setCaller(state: State, caller: string) {
        console.log(caller);
        state.caller = caller;
    },
};

/**
 * Module actions
 */
const moduleActions: ActionTree<State, any> = {

};

/**
 * Construct Module
 */
const module: Module<State, any> = {
    namespaced: true,
    state: moduleState,
    getters: moduleGetters,
    mutations: moduleMutations,
    actions: moduleActions,
};
export default module;
